import { ILocale } from 'modules/common/interfaces';

export const Float = (value: number) => value * 1000;
export const ReverseFloat = (value: number) => (value !== 0 ? value / 1000 : 0);

export const sum = (sum1: number, sum2: number) => {
  return ReverseFloat(Float(sum1) + Float(sum2));
};
export const multiply = (float: number, factor: number) => {
  return ReverseFloat(Float(float) * factor);
};

export const percentage = (value: number, total: number) => {
  const val = Float(value) / Float(total);
  return multiply(val, 100);
};

const LOCALES_MAP = {
  en: 'en-US',
  es: 'es-MX',
};

export const showPrice = (value: number, locale: ILocale = 'es') => {
  const formatter = new Intl.NumberFormat(LOCALES_MAP[locale], {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
};

export const abbrNumber = (value: number) => {
  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  } else if (value >= 1_000) {
    return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  } else {
    return value.toString();
  }
};

/**
 * Return a time string in format (x)h (y)m z(s)
 * @param seconds Time in seconds
 */
export const timeString = (seconds: number) => {
  let val = seconds;
  let result = '';
  if (val >= 3600) {
    result += `${Math.floor(val / 3600)}h `;
    val = val % 3600;
  }
  if (val >= 60) {
    result += `${Math.floor(val / 60)}m `;
    val = val % 60;
  }
  if (val >= 1) {
    result += `${Math.floor(val)}s `;
  } else {
    result = result || '0s';
  }
  return result.trim();
};
